import React, { useState, useEffect } from "react";

// common function
import { tideStationLatLon } from "../scripts/station";
import { tideMarker } from "../scripts/tideMarker";
import { fetchingTime } from "../../../../config/fetching";

// Style sheet
import "bootstrap/dist/css/bootstrap.min.css";
import "../scss/tideMap.scss";
// mapTitle sheet
import "../scss/mapTitleMap.scss";

// leaflet css
import "leaflet/dist/leaflet.css";
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css";
import "leaflet-defaulticon-compatibility";

// Openstreetmap components
import {
  MapContainer,
  TileLayer,
  Marker,
  useMap,
  ZoomControl,
} from "react-leaflet";
// L component
import Leaflet from "leaflet";

// Watermark
import Watermark from "../../../../resources/image/watermark.jpg";

import { getTideInformation } from "../../../service/apiWeatherInfoService";

//#region Map Watermark
const WatermarkControl = () => {
  const map = useMap();
  const watermark = map.getContainer().querySelector(".watermark");

  if (!watermark) {
    const watermark = new Leaflet.Control({ position: "bottomleft" });
    watermark.onAdd = function (map) {
      var div = Leaflet.DomUtil.create("div", "watermark");
      div.innerHTML = "<img src='" + Watermark + "' width='75' height='75'>";
      return div;
    };
    watermark.addTo(map);
    // React.useEffect(() => {

    // }, [map]);
  }

  return null;
};

//#endregion END

type Props = { enable: number; autoUpdate?: boolean };
type tideInfo_Props = { station: string; tide: string; time: string };

function TideMap({ enable, autoUpdate }: Props) {
  const [isMapOn, setIsMapOn] = useState<React.Key>(0);
  const [tideArray, setTideArray] = useState<Array<tideInfo_Props>>([]);
  const [time, setTime] = useState<string>("");

  const position: Leaflet.LatLngExpression = [22.35, 114.125];

  async function getFetchTideInfomation() {
    await getTideInformation()
      .then((response) => {
        return response.data.data;
      })
      .then((data) => {
        setTideArray(data);
        setTime(data[0].time);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    const fetchData = async () => {
      if (autoUpdate === true) {
        getFetchTideInfomation();
      }
    };

    getFetchTideInfomation(); // Initial fetch

    let intervalId = setInterval(() => {
      fetchData();
    }, fetchingTime);

    return () => {
      clearInterval(intervalId);
    };
  }, [autoUpdate]);

  useEffect(() => {
    setIsMapOn(enable);
  }, [enable]);

  return (
    <div className="mapContainer">
      <MapContainer
        zoom={11}
        maxZoom={12}
        minZoom={11}
        zoomControl={false}
        center={position}
        scrollWheelZoom={false}
        key={isMapOn}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        <ZoomControl position="topright" />

        <WatermarkControl />

        {tideArray.map((item) => {
          return (
            <Marker
              key={"tide-" + item.station}
              position={tideStationLatLon(item.station)}
              icon={tideMarker(item.tide)}
            />
          );
        })}
      </MapContainer>

      <div className="mapDescription">
        <div>各地潮位(海圖基準面以上)</div>
        <div>
          {time.substr(4, 2)}月{time.substr(6, 2)}日 {time.substr(8, 2)}:
          {time.substr(10, 2)}更新
        </div>
      </div>
    </div>
  );
}

export default TideMap;
